import styled from 'styled-components'
import Modal from 'react-modal'

export const StyledModal = styled(Modal)`
  position: absolute;
  inset: auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid rgb(204, 204, 204);
  background: rgb(255, 255, 255);
  border-radius: 10px;
  outline: none;
  padding: 21px;
  max-width: 530px;
  width: 100%;
  height: auto; 
  max-height: none;
  
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }
  @media(max-width: 580px) {
    max-height: 63vh;
    max-width: 320px;
  }

  `
export const TitleAndIconContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #D4E3E9; 
  padding-bottom: 19px;
`

export const TitleAndSubtitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

`

export const TitleText = styled.h1`
  font-weight: 600;
  font-size: 18px;
  color: #000;
`

export const SubTitleText = styled.h2`
  font-weight: 400;
  font-size: 14px;
  color: #4e6783;
`

export const CloseButtonIcon = styled.img`
  display: block;
  cursor: pointer;
`

export const DataContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
  padding-top: 19px;
`

export const TitleAndValueDataContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const DataTitleText = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #849AC5;
`

export const DataValueText = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #212D45;
`

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 9px;
  margin-top: 32px;
`

export const SaveButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 14px;
  height: 52px;
  background-color: #35C168;
  border-radius: 6px;
  font-weight: 500;
  font-size: 16px;
  color: #fff;
  width: 100%;
  cursor: pointer;
`

export const CancelButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 14px;
  height: 52px;
  background-color: transparent;
  border-radius: 6px;
  font-weight: 500;
  font-size: 16px;
  color: #212D45;
  width: 100%;
  max-width: 133px; 
  border: 1px solid #D4E3E9;
  cursor: pointer;

` 